import { Component, OnInit } from '@angular/core';
import { BaseModalContainer } from 'yt-ng-framework';
import { FakVrstaTroska } from './fak-vrsta-troska';
import { ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-fak-vrsta-troska',
  templateUrl: './fak-vrsta-troska.component.html'
})
export class FakVrstaTroskaComponent extends BaseModalContainer<FakVrstaTroska> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<FakVrstaTroska>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
